export const ERROR_MESSAGES = {
  REGISTRATION_FAILED: 'Failed to register. Please try again.',
  VERIFICATION_FAILED: 'Failed to verify code. Please try again.',
  RESEND_FAILED: 'Failed to resend code. Please try again.',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
} as const;

export const INFO_MESSAGES = {
  CONFIRMATION_EMAIL_SENT: 'We sent an email with a confirmation code to this email',
  CODE_NOT_RECEIVED: 'Access code not received? Please try to register again after',
  CHANGE_EMAIL: 'Change email',
} as const;

export const ACCESS_MESSAGES = {
  APPLICATIONS_LABEL: 'What applications you will use',
  APPLICATIONS_PLACEHOLDER: 'Enter applications names you need to access',
  ROLE_LABEL: 'Describe your role or use case',
  ROLE_PLACEHOLDER: 'Enter what is your interest and need with Digitalrealty',
} as const;
